import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Testimonio1 from "../../../images/modulo14/testimonio1.png";
import Testimonio2 from "../../../images/modulo14/testimonio2.png";
import Testimonio3 from "../../../images/modulo14/testimonio3.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad7.mp3";

const Actividad4 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[9];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[10].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[10].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[8].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[8].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
        <AudioPlayer track={Audio} />
        <div className="row">
        <div className="col-12">
          <ul>
            <li>
              Existen muchas razones por las que la educación bilingüe en el
              Perú es importante. Lee los siguientes testimonios y señala si las
              razones que dan para apoyar la educación bilingüe están a nivel
              personal, familiar o de la comunidad.
            </li>
          </ul>
          <div className="row mt-5 p-4 align-items-center">
            <div className="col-md-6">
              <h5>Testimonio 1</h5>
              <p className="p-4 fs-5">
                Yo estudio en una escuela bilingüe. Poco a poco fuimos
                aprendiendo castellano. Si me hubieran hablado de frente todo en
                castellano, no me hubiera atrevido a contestar.
              </p>
            </div>
            <div className="col-md-6">
              <img src={Testimonio1} className="img-fluid" alt="Testimonio" />
            </div>
            <div className="col-md-12">
              <p className="my-4 text-sm">
                La razón que da Eli muestra la importancia de la educación
                bilingüe a nivel:
              </p>
              <input type="text" className="form-control" />
            </div>
          </div>
          <div className="row mt-5 p-4 align-items-center mt-5">
            <div className="col-md-6">
              <h5>Testimonio 2</h5>
              <p className="p-4 fs-5">
                En mi colegio se enseña en awajún y en castellano. En mi
                comunidad, poco hablamos castellano. Al profesor se le ha
                ocurrido poner cartelitos por toda la comunidad con los nombres
                de las cosas en awajún y en castellano. Por ejemplo, en el
                camino ponemos “CAMINO – JÍNTA”.
              </p>
            </div>
            <div className="col-md-6">
              <img src={Testimonio2} className="img-fluid" alt="Testimonio" />
            </div>
            <div className="col-12">
              <p className="my-4 text-sm">
                La razón que da Jailer muestra la importancia de la educación
                bilingüe a nivel:
              </p>
              <input type="text" className="form-control" />
            </div>
          </div>
          <div className="row mt-5 p-4 align-items-center mt-5">
            <div className="col-md-6">
              <h5>Testimonio 3</h5>
              <p className="p-4 fs-5">
                Yo aprendí castellano y aimara en el colegio. Fue bueno porque
                mis papás casi todo me hablaban en castellano, pero el aimara
                era importante para comunicarme con mis abuelos y mis tíos
                mayores.
              </p>
            </div>
            <div className="col-md-6">
              <img src={Testimonio3} className="img-fluid" alt="Testimonio" />
            </div>
            <div className="col-12">
              <p className="my-4 text-sm">
                La razón que da José muestra la importancia de la educación
                bilingüe a nivel:
              </p>
              <input type="text" className="form-control" />
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades se resaltará la
            importancia de proteger y conservar las lenguas originarias. Para
            ello, las actividades que realizarán buscan tomar conciencia de
            ello, así como también tomar acción.
          </li>
          <li>
            Lea la primera indicación. Pida que lean los testimonios presentados
            por Eli (testimonio 1), Jailer (testimonio 2) y José (testimonio 3).
            Dé un tiempo para que trabajen individualmente. Retome las
            respuestas a cada uno de los casos y coméntelas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En el primer testimonio vemos que Eli apoya la educación
                  bilingüe. Para ella fue muy importante poder aprender en
                  quechua y poco a poco ir aprendiendo castellano. Entonces,
                  esta razón está a nivel personal ya que solo involucra a Eli.
                </i>
              </li>
              <li>
                <i>
                  “En el segundo testimonio, Jailer también cuenta que su
                  escuela es bilingüe, es decir, que aprenden en castellano y
                  awajún. Sin embargo, el profesor de Jailer considera que es
                  importante apoyar el bilingüismo a nivel de toda la comunidad.
                  Por ello, ha puesto los cartelitos en la comunidad con el
                  nombre de las cosas en los dos idiomas”.
                </i>
              </li>
              <li>
                <i>
                  “En el tercer testimonio, José menciona que aprendió en dos
                  idiomas, castellano y aimara, en la escuela. Ello resultó
                  importante para poder comunicarse a nivel familiar, ya que sus
                  abuelos y tíos mayores, solo hablan aimara, mientras que sus
                  padres lo hacen en español”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
